import { AxiosInstance } from 'axios';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import {
  SearchClientsRequest,
  SearchClientsResponse,
  CreateClientRequest,
  CreateClientResponse,
  UpdateClientRequest,
  UpdateClientResponse,
  DeleteClientRequest,
  DeleteClientResponse,
  GetClientRequest,
  GetClientResponse,
} from './ClientServices.types';

import { ClientContactServices } from './services';

export class ClientServices implements BaseRequestEndpoints {
  instance: AxiosInstance;
  contact: ClientContactServices;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.contact = new ClientContactServices(instance);
  }

  search(request: SearchClientsRequest) {
    return this.instance.get<SearchClientsResponse>('/clients', {
      params: request.queryParams,
    });
  }

  getById(request: GetClientRequest) {
    return this.instance.get<GetClientResponse>(`/clients/${request.routeParams.id}`);
  }

  create(request: CreateClientRequest) {
    return this.instance.post<CreateClientResponse>('/clients', request.body);
  }

  update(request: UpdateClientRequest) {
    return this.instance.put<UpdateClientResponse>(
      `/clients/${request.routeParams.id}`,
      request.body,
    );
  }

  delete(request: DeleteClientRequest) {
    return this.instance.delete<DeleteClientResponse>(`/clients/${request.routeParams.id}`);
  }
}
